import React from 'react';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';

import type { EligibleCruiseLinesModalProps } from './types';

import styles from './styles.module.scss';

export const EligibleCruiseLinesModal = (
  props: EligibleCruiseLinesModalProps,
): React.ReactElement => {
  const intl = useIntl();
  const { open, onClose, cruiseLines: cruises } = props;
  const cruiseLines = (cruises ?? []).map((cruise) => cruise.name).filter(Boolean);

  return (
    <Modal
      className={styles.modal}
      visible={open}
      title={intl.formatMessage({ id: 'certificates.eligibleCruise.modalTitle' })}
      onCancel={onClose}
      footer={null}
      closable
      width={440}
    >
      <div className={styles.content}>
        <p className={styles.intro}>
          {intl.formatMessage({ id: 'certificates.eligibleCruise.intro' })}
        </p>
        <ul className={styles.list}>
          {cruiseLines.map((line, index) => (
            <li key={`${line}-${index}`}>{line}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};
